import React from "react"

const Container = ({ children }) => (
  <div style={{ margin: "0 auto" }} className="bg-bgMain">
    {children}
  </div>
)

export default Container
